/* VIS TO ROCK — Application JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ── */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('open'));
    mobileClose && mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
  }

  /* ── CART COUNT UPDATE ── */
  updateCartCount();

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  /* ── ADD TO CART ── */
  document.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adicionando...';
      btn.disabled = true;

      try {
        const data = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: data });
        if (!res.ok) throw new Error('Erro ao adicionar');
        const item = await res.json();
        showCartOverlay(item.title);
        await updateCartCount();
      } catch (err) {
        alert('Selecione um tamanho antes de adicionar ao carrinho.');
      } finally {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  /* ── CART OVERLAY ── */
  window.showCartOverlay = function (title) {
    const overlay = document.getElementById('cart-overlay');
    const titleEl = document.getElementById('cart-overlay-title');
    if (overlay && titleEl) {
      titleEl.textContent = title;
      overlay.style.display = 'flex';
    }
  };

  window.closeCartOverlay = function () {
    const overlay = document.getElementById('cart-overlay');
    if (overlay) overlay.style.display = 'none';
  };

  document.getElementById('cart-overlay')?.addEventListener('click', function (e) {
    if (e.target === this) closeCartOverlay();
  });

  /* ── PRODUCT IMAGE GALLERY ── */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.product-main-img img');
      if (mainImg) mainImg.src = this.dataset.src;
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── SIZE SELECTOR ── */
  document.querySelectorAll('.size-option').forEach(option => {
    option.addEventListener('click', function () {
      const group = this.closest('.size-options');
      group.querySelectorAll('.size-option').forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
      const hiddenInput = this.closest('form')?.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = this.dataset.variantId;
    });
  });

  /* ── CART QTY BUTTONS ── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.qty-input');
      const delta = this.dataset.action === 'plus' ? 1 : -1;
      const newVal = Math.max(1, parseInt(input.value || 1) + delta);
      input.value = newVal;
    });
  });

});
